/* eslint-disable import/no-anonymous-default-export */
import { REDUCE_SIDEBAR } from "./actionTypes";
import { REDUCE_MODAL_DATA } from "./actionTypes";

const initialState: any = {
  reduceSideBar: false,
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case REDUCE_SIDEBAR:
      return {
        ...state,
        reduceSideBar: action.payload,
      };
    
    case REDUCE_MODAL_DATA:
      return {
        ...state,
        modalData: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
